import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { ClientService } from 'src/app/shared/service/disbursment/client.service';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { MaClient } from '../../../dis-repository/pages/create-client/client.model';
import { CreateClientComponent } from '../../../dis-repository/pages/create-client/create-client.component';
import { ViewMoreComponent } from '../../../dis-repository/pages/create-client/view-more/view-more.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent {
displayedColumns: string[] = ['Sl.No', 'client', 'Action'];
  dataSource = new MatTableDataSource<MaClient>();

  searchTerm: string = '';
 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  private searchSubject = new Subject<string>();

  currentPage = 1;
  pageSize = 50;
  totalCount = 0;
  allDataLoaded = false;

  constructor(
    private dialog: MatDialog,
    private clientService: ClientService,
     private requestFormService: RequestFormService,
  ) { }

  ngOnInit() {
    this.getMaClientDataFromDb(true);

    // Setup debounce for search
    this.searchSubject
      .pipe(
        debounceTime(1000)
      )
      .subscribe(() => {
        this.onSearch();
      });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  inputSearch(): void {
    if (this.searchTerm.trim() === '') {
      this.onSearch();
    } else {
      this.searchSubject.next(this.searchTerm);
    }
  }

  // Scroll handler
  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');
    if (scrollContainer) {
      const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;

      if (scrollPosition >= scrollHeight - 10 && !this.loader.loading$ && !this.allDataLoaded) {
        this.getMaClientDataFromDb();
      }
    }
  }

  onSearch(): void {
    this.getMaClientDataFromDb(true);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.getMaClientDataFromDb(true);
  }

  getMaClientDataFromDb(reset = false): void {
    if (reset) {
      this.currentPage = 1;
      this.dataSource.data = [];
      this.totalCount = 0;
      this.allDataLoaded = false;
    }

    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query: this.searchTerm.trim(),
      status: "Y"
    };

    this.loader.show();

    this.clientService.ClientDataFromDb(body).subscribe({
      next: (response: { data: MaClient[]; total_count: number }) => {
        this.totalCount = response.total_count;
        this.dataSource.data = [...this.dataSource.data, ...response.data];

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.loader.hide();
      },
      error: () => {
        this.loader.hide();
      }
    });
  }

  openAddClientDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreateClientComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getMaClientDataFromDb(true);
      }
    });
  }

  openEditClientDialog(rowData: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.data = { rowData };
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreateClientComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getMaClientDataFromDb(true);
      }
    });
  }

  openDialog(vslPayLoad: any) {
    this.loader.show();
    const body = {
      company_id: vslPayLoad.company_id,
      fields: ["assigned_unassigned"]
    };

    this.clientService.VslListFromDb(body).subscribe({
      next: (response: any) => {
        this.loader.hide();
        const data = {
          clientName: vslPayLoad.company_name,
          clientStatus: vslPayLoad.status === "Y" ? "Active" : "Inactive",
          vslList: response.assigned_vessels,
          email: vslPayLoad.email || []
        };
        this.dialog.open(ViewMoreComponent, {
          data,
          // panelClass: 'custom-dialog-panel',
          width: '450px',
          height: '90vh',
        });
      },
      error: (err) => {
        this.loader.hide();
      }
    });
  }
     isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
